import { create } from 'zustand';

interface User {
  id: string;
  telegramId: string;
  firstName: string;
  lastName: string | null;
  username: string | null;
  photoUrl: string | null;
}

interface AuthState {
  user: User | null;
  initData: string | null;
  isLoading: boolean;
  setUser: (user: User) => void;
  setInitData: (initData: string) => void;
  logout: () => void;
}

export const useAuthStore = create<AuthState>((set) => ({
  user: null,
  initData: null,
  isLoading: false,
  
  setUser: (user) => set({ user, isLoading: false }),
  
  setInitData: (initData) => set({ initData }),
  
  logout: () => set({ user: null, initData: null }),
}));







































